<template lang="html">
  <div class="proactive mt-5">
    <div class="proactive-bg">
      <img src="../../assets/img/proactive-icon.svg" alt="">
    </div>
    <div class="proactive-text">
      <h2>Proactive Health Monitoring.</h2>
      <h2 class="blue-text">In Real Time.</h2>
      <p class="mt-3">Our device and mobile app allow you to get reliable and actionable data in just three easy steps.</p>
      <p>1. Collect vaginal fluids</p>
      <p>2. Place the sample in the device</p>
      <p>3. Wait for 5 minutes for the results to show on your app.</p>
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
  .proactive {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    grid-auto-rows: minmax(.5fr, auto);
    grid-gap: 1em;
  }
  .proactive-bg {
    display: none;
  }
  .proactive-text {
    grid-column: 2/12;
    grid-row: 1;
    text-align: left;
  }
  @media (min-width: 992px) {
    .proactive {
      padding-top: 2em;
    }
    .proactive-bg {
      display: block;
      grid-column: 2/6;
      grid-row: 3;
      align-self: left;
    }
    .proactive-text {
      grid-column: 6/12;
      grid-row: 1/12;
      text-align: left;
    }
  }
  @media (min-width: 1200px) {
    .proactive {
      padding-top: 5em;
    }
    .proactive-bg {
      display: block;
      grid-column: 3/6;
      grid-row: 2;
      align-self: left;
    }
    .proactive-text {
      grid-column: 7/11;
      grid-row: 1/12;
      text-align: left;
    }
  }
</style>
